"use client";

import { useState } from "react";
import Image from "next/image";
import "./style.scss";
import Lightbox from "./Lightbox";

interface PlaygroundItem {
	id: number;
	type: "tall" | "short";
	image: string;
	alt: string;
	width: number;
	height: number;
	lgImage: string;
	lgImgWidth: number;
	lgImgHeight: number;
}

const playgroundItems: PlaygroundItem[] = [
	{ id: 1, type: "tall", image: "/playground/1.webp", alt: "A logo", width: 234, height: 326, lgImage: "/playground/1-lg.webp", lgImgWidth: 702, lgImgHeight: 908 },
	{ id: 2, type: "short", image: "/playground/2.webp", alt: "Business card", width: 234, height: 246, lgImage: "/playground/2-lg.webp", lgImgWidth: 702, lgImgHeight: 738},
	{ id: 3, type: "tall", image: "/playground/3.webp", alt: "Website design of an hero section", width: 234, height: 293, lgImage: "/playground/3-lg.webp", lgImgWidth: 702, lgImgHeight:  879},
	{ id: 4, type: "short", image: "/playground/4.webp", alt: "Brand poster", width: 234, height: 293, lgImage: "/playground/4-lg.webp", lgImgWidth: 702, lgImgHeight:  879},
	{ id: 5, type: "short", image: "/playground/5.webp", alt: "Website design for a portfolio website", width: 234, height: 197, lgImage: "/playground/5-lg.webp", lgImgWidth: 702, lgImgHeight: 591},
	{ id: 6, type: "tall", image: "/playground/6.webp", alt: "Brand design of an app logo", width: 234, height: 326, lgImage: "/playground/6-lg.webp", lgImgWidth: 702, lgImgHeight:  978},
];

const Playground = () => {
	const [lightboxOpen, setLightboxOpen] = useState(false);
	const [currentImageIndex, setCurrentImageIndex] = useState(0);

	const handleImageClick = (index: number) => {
		// Only open lightbox on desktop (screen width > 768px)
		if (window.innerWidth > 768) {
			setCurrentImageIndex(index);
			setLightboxOpen(true);
		}
	};

	const handleNavigate = (direction: "prev" | "next") => {
		if (direction === "prev") {
			setCurrentImageIndex((prev) => (prev === 0 ? playgroundItems.length - 1 : prev - 1));
		} else {
			setCurrentImageIndex((prev) => (prev === playgroundItems.length - 1 ? 0 : prev + 1));
		}
	};
	return (
		<section className="playground-section">
			<h2>Playground</h2>
			<div className="playground-marquee">
				<div className="playground-marquee__track">
					{/* First set */}
					<div className="playground-marquee__content">
						{playgroundItems.map((item, index) => (
							<div key={`item-1-${item.id}`} className={`playground-marquee__item playground-marquee__item--${item.type}`} onClick={() => handleImageClick(index)}>
								<Image src={item.image} alt={`Playground item: ${item.alt}`} width={item.width} height={item.height} style={{ width: `${item.width / 10}rem`, height: `${item.height / 10}rem` }} className="playground-marquee__image" />
							</div>
						))}
					</div>

					{/* Duplicate set for seamless loop */}
					<div className="playground-marquee__content" aria-hidden="true">
						{playgroundItems.map((item, index) => (
							<div key={`item-2-${item.id}`} className={`playground-marquee__item playground-marquee__item--${item.type}`} onClick={() => handleImageClick(index)}>
								<Image src={item.image} alt={`Playground item: ${item.alt}`} width={item.width} height={item.height} style={{ width: `${item.width / 10}rem`, height: `${item.height / 10}rem` }} className="playground-marquee__image" />
							</div>
						))}
					</div>
					{/* First set */}
					{/* <div className="playground-marquee__content">
						{playgroundItems.map((item) => (
							<div key={`item-3-${item.id}`} className={`playground-marquee__item playground-marquee__item--${item.type}`}>
								<Image src={item.image} alt={`Playground item: ${item.alt}`} width={item.width} height={item.height} style={{ width: `${item.width / 10}rem`, height: `${item.height / 10}rem` }} className="playground-marquee__image" />
							</div>
						))}
					</div> */}

					{/* Duplicate set for seamless loop */}
					{/* <div className="playground-marquee__content" aria-hidden="true">
						{playgroundItems.map((item) => (
							<div key={`item-4-${item.id}`} className={`playground-marquee__item playground-marquee__item--${item.type}`}>
								<Image src={item.image} alt={`Playground item: ${item.alt}`} width={item.width} height={item.height} style={{ width: `${item.width / 10}rem`, height: `${item.height / 10}rem` }} className="playground-marquee__image" />
							</div>
						))}
					</div> */}
				</div>
			</div>

			{lightboxOpen && <Lightbox images={playgroundItems} currentIndex={currentImageIndex} onClose={() => setLightboxOpen(false)} onNavigate={handleNavigate} />}
		</section>
	);
};

export default Playground;
